const PageRequests = () =>
  import(/* webpackChunkName: "requests" */ '@/pages/eDispatch/Home.vue');

const RequestsFilter = () =>
  import(/* webpackChunkName: "requests" */ '@/pages/eDispatch/RequestFilter');

const RequestsTop = () =>
  import(
    /* webpackChunkName: "requests" */ '@/pages/eDispatch/RequestsTop.vue'
  );
export const REQUESTS_LIST_ROUTE_NAME = 'requests';

export default {
  getRequestsRoute() {
    return {
      path: 'requests',
      name: REQUESTS_LIST_ROUTE_NAME,
      components: {
        top: RequestsTop,
        default: PageRequests,
        'right-drawer': RequestsFilter,
      },
      meta: {
        authorizations: ['isMy360'],
        isHidden: false,
        title: 'requests',
        icon: 'local_shipping',
      },
    };
  },
};
